import classes from './loader.module.scss';

const Loader = ({
  displayInContainer = false,
}: {
  displayInContainer?: boolean;
}) => {
  return (
    <div
      className={`${classes['page-spinner']} ${displayInContainer ? classes['within-parent'] : ''}`}
    >
      <span
        className={`${classes['spinner-icon']} ${displayInContainer ? classes['within-parent'] : ''}`}
      ></span>
    </div>
  );
};

export default Loader;
